<template>
  <div class="tag" :class="classes">
    <slot>
      <span class="title">{{ title || '' }}</span>
    </slot>
  </div>
</template>

<script setup lang="ts">
interface Props {
  title?: string
}
withDefaults(defineProps<Props>(), { title: '' })
const classes = computed(() => ({}))
</script>

<style scoped lang="scss">
@use "~/assets/styles/colors.scss" as *;

.tag {
  display: inline-flex;
  width: fit-content;
  padding: 6px 14px;
  font-size: 14px;
  border-radius: 16px;
  background: #f5f7f9;
  color: #23272f;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;

  > .title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
